<template>
  <div class="aw-page">
    <HeadNav selectedLanguage="en" page="old-versions" />
    <main>
      <section class="content-section">
        <h1>GB WhatsApp Old Versions – Previous APK Releases</h1>
        <p>Looking for an older version of GB WhatsApp? Here you can find previous GB WhatsApp APK releases and choose a version that works better with your Android device.</p>
        <p>Older versions can be useful if the latest GB WhatsApp update causes compatibility problems, changes certain features, or does not work properly on your device. Before installing an older APK, back up your chats and media to avoid losing important data.</p>
        <router-link class="primary-action" :to="{ name: 'gb-whatsapp-apk' }">Download Latest Version 18.80</router-link>
      </section>

      <section class="content-section">
        <h2>Available GB WhatsApp APK Versions</h2>
        <SimpleTable caption="Available GB WhatsApp APK versions" :columns="infoCols" :rows="infoRows" />
      </section>

      <section v-for="group in versionGroups" :key="group.title" class="content-section">
        <h2>{{ group.title }}</h2>
        <div class="version-cards">
          <article v-for="item in group.items" :key="item.version" class="version-card">
            <img class="version-card__logo" src="@/assets/logo.webp" alt="GB WhatsApp logo" width="72" height="72" loading="lazy">
            <h3>GB WhatsApp v{{ item.version }}</h3>
            <ul>
              <li><strong>Version:</strong> {{ item.version }}</li>
              <li v-if="item.size"><strong>Size:</strong> {{ item.size }}</li>
              <li><strong>Published:</strong> {{ item.published }}</li>
              <li><strong>Android:</strong> {{ item.android }}</li>
            </ul>
            <button class="primary-action version-card__download" type="button" @click="download">
              <svg class="primary-action__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 3v10.7m0 0 4.2-4.2M12 13.7 7.8 9.5M5 17.5V20h14v-2.5" />
              </svg>
              <span>Download APK</span>
            </button>
          </article>
        </div>
      </section>

      <section class="content-section lower-block lower-block--start">
        <h2>Why Use an Older GB WhatsApp Version?</h2>
        <article class="prose-card">
          <p>Some users prefer an older version because it works better on their device or includes features they prefer. An older release can also be useful when a new update causes crashes, compatibility problems, or unwanted changes.</p>
          <p>If your current version works correctly, there is usually no need to downgrade. Choose an older APK when you have a specific reason to use that release.</p>
        </article>
      </section>

      <section class="content-section lower-block">
        <h2>Which GB WhatsApp Version Should I Choose?</h2>
        <article class="prose-card">
          <p>Choose the newest older version that is compatible with your Android device. Going back only one or two releases can help you avoid problems while still keeping many of the newer features.</p>
          <p>If you need a specific feature or previous interface, check the version details before downloading.</p>
        </article>
      </section>

      <section class="content-section lower-block">
        <h2>How to Install an Old GB WhatsApp Version</h2>
        <article class="prose-card">
          <ol class="guide-steps">
            <li>
              <span class="guide-steps__num" aria-hidden="true">1</span>
              <span class="guide-steps__text">First, back up your chats and media. Download the APK for the version you want, enable APK installation from your Android settings if required, and install the file.</span>
            </li>
            <li>
              <span class="guide-steps__num" aria-hidden="true">2</span>
              <span class="guide-steps__text">If you already have a newer version installed, compatibility or signature conflicts may prevent the older APK from installing. In this situation, make sure your important data is backed up before removing or changing the existing installation.</span>
            </li>
          </ol>
        </article>
      </section>

      <section class="content-section lower-block">
        <h2>Can I Downgrade GB WhatsApp?</h2>
        <article class="prose-card">
          <p>Yes, but downgrading may cause data or compatibility problems. Always create a backup before switching to an older release, and make sure the version you choose supports your Android device.</p>
        </article>
      </section>

      <section class="content-section lower-block">
        <h2>Are Old GB WhatsApp Versions Safe?</h2>
        <article class="prose-card">
          <p>Older versions may not include the latest bug fixes, compatibility improvements, or security-related changes. Only download APK files from a source you trust and avoid modified files from unknown websites.</p>
        </article>
      </section>

      <section class="content-section lower-block">
        <h2>Old Version vs Latest Version</h2>
        <SimpleTable caption="Old version vs latest version" :columns="compareCols" :rows="compareRows" />
        <p>For most users, the latest compatible GB WhatsApp version is the better choice. Older versions are mainly useful when you need a previous feature or experience compatibility problems with a newer release.</p>
      </section>

      <FaqList title="GB WhatsApp Old Versions FAQ" :items="faqs" />
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/site.scss';
import HeadNav from '@/components/HeadNav.vue';
import FaqList from '@/components/FaqList.vue';
import SimpleTable from '@/components/SimpleTable.vue';
import apkDownload from '@/mixins/apkDownload';

export default {
  name: 'OldVersions',
  components: { HeadNav, FaqList, SimpleTable },
  mixins: [apkDownload],
  data() {
    return {
      infoCols: ['App Information', 'Details'],
      infoRows: [
        ['App Name', 'GB WhatsApp APK'],
        ['Versions', 'v18.80 to v2.17'],
        ['APK Size', 'Approximately 27–95 MB'],
        ['Required Android', 'Android 4.0+'],
        ['Developer', 'AlexMods'],
        ['License', 'Freeware'],
        ['Available Since', '2015–2026'],
      ],
      versionGroups: [
        {
          title: 'GB WhatsApp Versions 2026',
          items: [
            { version: '18.80', size: '78 MB', published: 'April 2026', android: '5.0+' },
            { version: '18.70', size: '77 MB', published: 'February 2026', android: '5.0+' },
            { version: '18.60', size: '65 MB', published: 'January 2026', android: '5.0+' },
          ],
        },
        {
          title: 'GB WhatsApp Versions 2025',
          items: [
            { version: '18.50', size: '76 MB', published: 'December 2025', android: '5.0+' },
            { version: '18.00', size: '76 MB', published: 'November 2025', android: '5.0+' },
            { version: '17.90', size: '79 MB', published: 'October 2025', android: '5.0+' },
            { version: '17.80', size: '75 MB', published: 'September 2025', android: '5.0+' },
            { version: '17.50', size: '70 MB', published: 'August 2025', android: '5.0+' },
            { version: '17.00', size: '69 MB', published: 'July 2025', android: '5.0+' },
            { version: '16.80', size: '65 MB', published: 'June 2025', android: '5.0+' },
            { version: '16.50', size: '73 MB', published: 'May 2025', android: '5.0+' },
            { version: '16.00', size: '73 MB', published: 'April 2025', android: '5.0+' },
          ],
        },
        {
          title: 'GB WhatsApp Versions 2024',
          items: [
            { version: '15.00', size: '58 MB', published: 'December 2024', android: '4.0+' },
            { version: '14.60', size: '56 MB', published: 'October 2024', android: '4.0+' },
            { version: '14.20', size: '55 MB', published: 'August 2024', android: '4.0+' },
            { version: '13.80', size: '53 MB', published: 'June 2024', android: '4.0+' },
          ],
        },
        {
          title: 'Older GB WhatsApp Versions',
          items: [
            { version: '13.60', published: '2023', android: '3.0+' },
            { version: '11.50', published: '2021', android: '3.0+' },
            { version: '11.00', published: '2021', android: '3.0+' },
            { version: '10.00', published: '2020', android: '3.0+' },
            { version: '9.98', published: '2019', android: '3.0+' },
            { version: '8.80', published: '2019', android: '3.0+' },
            { version: '8.75', published: '2018', android: '3.0+' },
            { version: '7.60', published: '2018', android: '3.0+' },
            { version: '7.00', published: '2017', android: '3.0+' },
            { version: '5.00', published: '2017', android: '3.0+' },
            { version: '3.00', published: '2016', android: '3.0+' },
            { version: '2.00', published: '2015', android: '3.0+' },
            { version: '1.10', published: '2015', android: '3.0+' },
          ],
        },
      ],
      compareCols: ['Feature', 'Old Version', 'Latest Version'],
      compareRows: [
        ['Older interface', 'Yes', 'Depends on release'],
        ['Previous features', 'Yes', 'Updated'],
        ['Latest improvements', 'Limited', 'Yes'],
        ['Compatibility', 'May vary', 'Usually better'],
        ['Manual installation', 'Yes', 'Yes'],
      ],
      faqs: [
        { question: 'Why would I need an old GB WhatsApp version?', answer: 'An older version may work better with your device or provide a feature that was changed in a newer release.' },
        { question: 'Can I install an old version over a newer version?', answer: 'It may not always work because Android can detect a version or signature conflict. Back up your data before changing versions.' },
        { question: 'Will I lose my chats when downgrading?', answer: 'There is a risk of losing data when switching versions. Create a complete backup before installing an older APK.' },
        { question: 'Which old GB WhatsApp version is best?', answer: 'The best version depends on your Android device and the features you need. In most cases, choose the newest compatible older release.' },
        { question: 'Can I update the old version later?', answer: 'Yes. You can update to a newer compatible version when an update is available. Back up your chats before updating.' },
      ],
    };
  },
};
</script>
